var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-field"},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('router-link',{class:_vm.linkClass,attrs:{"to":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }